// Report our content height to a parent page so an embedding iframe can size to fit
// (removes the internal iframe scrollbar). Payload shape is namespaced under
// `roiIframeHeight` so the host page can filter our messages. The host is responsible
// for verifying event.origin before applying the height.
//
// Previously an inline <script> at the bottom of the application layout; moved here so
// it is covered by the script-src 'self' CSP directive instead of tripping a violation.
// Still vanilla JS on purpose: it makes no assumptions about jQuery being ready, and
// every DOM access below is guarded, so running from the head pack is safe.
(function () {
  // Only emit when actually embedded (top-level page has no parent to notify).
  if (!window.parent || window.parent === window) return;

  var lastHeight = 0;
  var scheduled = false;

  // Not documentElement.scrollHeight: it never drops below the iframe's own height, so
  // once the host grew the iframe we could never shrink it (e.g. phone portrait ->
  // landscape left a tall blank gap). The <html> box is sized by content alone; the body
  // term covers a page whose html/body are pinned to 100% with content overflowing them.
  function contentHeight() {
    var doc = document.documentElement;
    var body = document.body;
    var h = doc ? doc.getBoundingClientRect().height : 0;
    if (body) {
      var style = window.getComputedStyle(body);
      h = Math.max(h, body.scrollHeight + parseFloat(style.marginTop) + parseFloat(style.marginBottom));
    }
    return Math.ceil(h);
  }

  // `force` skips the de-dupe, for when the host may have missed earlier messages.
  function postHeight(force) {
    var h = contentHeight();
    if (!h || (h === lastHeight && !force)) return; // avoid flooding the host with no-op messages
    lastHeight = h;
    window.parent.postMessage({ roiIframeHeight: h }, '*');
    // Avalara's embed component ignores roiIframeHeight and sizes the iframe only from
    // this message shape (its "hc:calculator:*" protocol; see dev1.avlr.net embed.html).
    window.parent.postMessage({ type: 'hc:calculator:resize', height: h }, '*');
  }

  // Coalesce bursts (ResizeObserver + resize can fire many times per frame).
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      postHeight();
    });
  }

  // The host can ask for the current height, e.g. if its listener attached after our
  // load (otherwise it would only hear from us when the height next changes).
  window.addEventListener('message', function (event) {
    if (event.source === window.parent && event.data && event.data.roiIframeHeightRequest) {
      postHeight(true);
    }
  });

  // Initial height once assets have settled, then repeated a few times for a host
  // whose listener attaches late and which doesn't send roiIframeHeightRequest.
  function onLoad() {
    postHeight(true);
    [500, 1500, 3000].forEach(function (ms) {
      window.setTimeout(function () { postHeight(true); }, ms);
    });
  }
  if (document.readyState === 'complete') {
    onLoad();
  } else {
    window.addEventListener('load', onLoad);
  }
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);

  // Re-report on any content-box change: responsive reflow, charts rendering,
  // modals opening, override rows expanding, etc. <html> too, so a margin change on
  // the body's last child (which collapses through the body) is still noticed.
  if (typeof ResizeObserver !== 'undefined') {
    var ro = new ResizeObserver(schedule);
    ro.observe(document.documentElement);
    var observeBody = function () { if (document.body) ro.observe(document.body); };
    if (document.body) {
      observeBody();
    } else {
      window.addEventListener('DOMContentLoaded', observeBody);
    }
  }

  // Fallback for viewport changes (also covers the chart resize trigger in
  // chart_width_fix.js), and for rotation/back-forward cache restores on mobile,
  // which don't always fire resize.
  window.addEventListener('resize', schedule);
  window.addEventListener('orientationchange', schedule);
  window.addEventListener('pageshow', function () { postHeight(true); });
})();
